<dx-box width="100%" height="100%" direction="col" class="box-container">
    <dxi-item [ratio]="1" [visible]="!hasSourceData">
        <div *dxTemplate>
            <div class="no-data-container">There is no history data.</div>
        </div>
    </dxi-item>

    <dxi-item [ratio]="1" *ngIf="hasSourceData && useGridFeatures">
        <div *dxTemplate>
            <cc-data-grid-features *ngIf="useGridFeatures" [dataSource]="historySource">
                <dx-data-grid
                    width="100%"
                    height="100%"
                    allowColumnResizing="true"
                    [dataSource]="historySource"
                    [showColumnLines]="true"
                    [showRowLines]="true"
                    [hoverStateEnabled]="true"
                    [columnAutoWidth]="true"
                    [showBorders]="true"
                    [columns]="columnDef"
                >
                    <dxo-filter-row [visible]="allowColumnFilter"></dxo-filter-row>
                    <div *dxTemplate="let row of 'userTemplate'">
                        <app-user-bio-link
                            *ngIf="!userDataField"
                            [user]="row.value"
                            [communityId]="communityId"
                        ></app-user-bio-link>
                        <ng-container
                            *ngIf="userDataField"
                            [ngTemplateOutlet]="singleUserTemplate"
                            [ngTemplateOutletContext]="getSingleUserTemplateContext(row)"
                        ></ng-container>
                    </div>
                    <div *dxTemplate="let row of 'userColumnWithFilterTemplate'">
                        <app-user-bio-link [user]="row.data.updatedBy" [communityId]="communityId"></app-user-bio-link>
                    </div>
                    <div *dxTemplate="let d of 'dateTemplate'">
                        {{ getDateAsPerUserPreference(d.value) }}
                    </div>
                </dx-data-grid>
            </cc-data-grid-features>
        </div>
    </dxi-item>
    <dxi-item [ratio]="1" *ngIf="hasSourceData && !useGridFeatures">
        <div *dxTemplate>
            <dx-data-grid
                height="100%"
                allowColumnResizing="true"
                [dataSource]="historySource"
                [showColumnLines]="true"
                [showRowLines]="true"
                [hoverStateEnabled]="true"
                [columnAutoWidth]="true"
                [showBorders]="true"
                [columns]="columnDef"
            >
                <dxo-filter-row [visible]="allowColumnFilter"></dxo-filter-row>
                <dxo-paging [enabled]="allowPaging"></dxo-paging>
                <div *dxTemplate="let row of 'userTemplate'">
                    <app-user-bio-link
                        *ngIf="!userDataField"
                        [user]="row.value"
                        [communityId]="communityId"
                    ></app-user-bio-link>
                    <ng-container
                        *ngIf="userDataField"
                        [ngTemplateOutlet]="singleUserTemplate"
                        [ngTemplateOutletContext]="getSingleUserTemplateContext(row)"
                    ></ng-container>
                </div>
                <div *dxTemplate="let row of 'userColumnWithFilterTemplate'">
                    <app-user-bio-link [user]="row.data.updatedBy" [communityId]="communityId"></app-user-bio-link>
                </div>
                <div *dxTemplate="let d of 'dateTemplate'">
                    {{ getDateAsPerUserPreference(d.value) }}
                </div>
            </dx-data-grid>
        </div>
    </dxi-item>
</dx-box>

<ng-template #singleUserTemplate let-user="user">
    <app-user-bio-link [user]="user" [communityId]="communityId"></app-user-bio-link>
</ng-template>
